import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import UI from "../../shared/Components/UI/js";
// import TouchableOpacity, { mem, StyleSheet, Text, View } from "../../shared/custom-react-native";
import MainLayout from "../_components/MainLayout";
import FinanceUserGroupSubscriptionListTable from "./FinanceUserGroupSubscriptionListTable";
// import "./css.css";


export default class FinanceUserGroupSubscriptioList extends Component {
  constructor(props) {
    super(props);
    UI.initiateView(this, {
      //Initial State Here
      active_tab: "Subscription List",
      is_drawer_open: false,
      selected: null,
      context:"finance"
    });
  }
  
  render() {
    const _this = this;

    return (
      <MainLayout context={this.state.context} additional={"subscriptions"} _this={_this}>
        <FinanceUserGroupSubscriptionListTable/>
      </MainLayout>
    );
  }
}
